import { ajaxPostJson } from './ajax'
// 获取原用户信息
export const olduserInfo = (params) => {
  return ajaxPostJson(`/user/getOldUserInfo`, params, 'BaseApi')
}

// 获取用户信息
export const userInfo = (params) => {
  return ajaxPostJson(`/user/getUserInfo`, params, 'BaseApi')
}

// 获取全部语言列表信息
export const languageInfo = (params) => {
  return ajaxPostJson(`/common/queryAllLang`, params)
}

// 更新用户语言、个人信息
export const newLangList = (params) => {
  return ajaxPostJson(`/user/update`, params)
}

// 不需要验证码的重置密码
export const resetPassword = (params) => {
  return ajaxPostJson(`/user/notVerifyResetPassword`, params)
}

//获取我的团队信息
export const teamInfo = (params) => {
  return ajaxPostJson(`/user/getMyTeam`, params)
}

// 获取我加入的团队信息
export const MyJoinTeamInfo = (params) => {
  return ajaxPostJson(`/user/getMyJoinedTeam`, params)
}

// 修改团队名称
export const resetTeamName = (params) => {
  return ajaxPostJson(`/company/updateCompanyName`, params)
}

// 用户同意或退出团队邀请
export const logoutTeam = (params) => {
  return ajaxPostJson(`/companyUser/quiteUserCompany`, params)
}

// 查看团队成员
export const checkTeamNum = (params) => {
  return ajaxPostJson(`/companyUser/queryPageByCompanyCode`, params)
}
// 切换团队
export const changeTeam = (params) => {
  return ajaxPostJson(`/user/changeCompany`, params)
}
